import React, { Component, createRef } from 'react'
import PropTypes from 'prop-types'
import Tooltip from '../Tooltip/Tooltip'

import Icon from '../Icon'

import ClickListener from '../../utils/useClickOutside'
import isTextEllipsisShown from '../../utils/isTextEllipsisShown'

import './selectStyles.scss'

class SelectUi extends Component {
  constructor (props) {
    super(props)

    this.state = {
      selectedItem: '',
      selectedItemObj: {},
      isOpen: false,
      tooltipTarget: null
    }

    this.wrapperRef = createRef()
  }

  componentDidMount () {
    const { optionsEnums, value }  = this.props
    const foundedItem = optionsEnums && optionsEnums.find(item => item.ID === value)
    this.setState({
      selectedItem: value || undefined,
      selectedItemObj: foundedItem || {}
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { optionsEnums, value }  = this.props

    if(prevProps !== this.props) {
      const foundedItem = optionsEnums && optionsEnums.find(item => item.ID === value)
      if(optionsEnums.length === 1 || !foundedItem) {
        this.setState({
          selectedItem: '',
          selectedItemObj: {}
        })
      }  else {
        this.setState({
          selectedItem: this.props.value,
          selectedItemObj: foundedItem || {}
        })
      }
    }
  }

  toggleDropdown = () => {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  closeDropdown = () => {
    this.setState({
      isOpen: false
    })
  }

  onChange = (e) => {
    const { optionsEnums, onInputChanged }  = this.props
    const newValue = e.target.id

    const foundedItem = optionsEnums && optionsEnums.find(item => item.ID === newValue)

    this.setState({
      selectedItem: newValue,
      isOpen: false,
      selectedItemObj: foundedItem
    })

    onInputChanged(e)
  }

  onKeyDownClose = (e) => {
    if (e.key === 'Enter' || e.keyCode === 13 || e.keyCode === 27) {
     this.setState({
       isOpen: !this.state.isOpen
     })
    }
  }

  hideTooltip = () => () => {
    this.setState({ tooltipTarget: null })
  }

  showTooltip = (itemID, itemName, className) => () => {
    this.setState({
      tooltipTarget: {
        id: itemID,
        name: itemName,
        className
      }
    })
  }

  ellipsisIsShown = () => {
    const { tooltipTarget } = this.state

    return tooltipTarget && isTextEllipsisShown(
      `.select-component .${tooltipTarget.className}[id="${tooltipTarget.id}"]`
    )
  }

  render () {
    const { isOpen, selectedItem, tooltipTarget, selectedItemObj } = this.state
    const { readonly, optionsEnums }  = this.props

    return (
      <ClickListener trigger={this.closeDropdown}>
        <div
          onClick={!readonly ? this.toggleDropdown : null}
          onKeyDown={this.onKeyDownClose}
          role="listbox"
          tabIndex="0"
          ref={this.wrapperRef}
          className={`select-component ${isOpen ? 'focused' : ''} 
          ${readonly || (Object.keys(selectedItemObj).length === 0 && optionsEnums.length === 1) ? 'disabled' : ''}`}
          data-xmpie-focusable="true"
        >
          <Icon
            name={`${isOpen ? 'arrowUp.svg' : 'arrowDown.svg'}`}
            width="16px"
            height="20px"
            classes="select-icon"
          />
          <div
            id='dropdown__selected'
            className='select-header'
            data-value={selectedItem}
            onMouseLeave={this.hideTooltip()}
            onMouseEnter={Object.keys(selectedItemObj).length > 0 ? this.showTooltip(
                selectedItemObj.ID.replaceAll(/[`'"]+/g, ''),
                selectedItemObj.Name,
                'select-header') : null
            }
          >
            {Object.keys(selectedItemObj).length > 0 && selectedItemObj.ID === selectedItem
              ? selectedItemObj.Name
              : readonly || (Object.keys(selectedItemObj).length === 0 && optionsEnums.length === 1)
                ? ''
                : optionsEnums[0].Name
            }
          </div>
          <div
            tabIndex="0"
            className={`select-body ${isOpen ? 'open' : ''} `}
            aria-label="submenu"
            role="menu"
            aria-expanded="false"
            aria-labelledby="dropdown-body"
          >
            {optionsEnums.map((item, index) => {
              const id = item.ID.replaceAll('`', '').replaceAll(`'`, '').replaceAll(`"`, '')

              return (
                <div
                  tabIndex="0"
                  className={`select-item dots ${item.ID === selectedItem ? 'selected' : ''}`}
                  aria-label={`${item.ID === selectedItem ? 'selected' : ''} ${item.ID}`}
                  onClick={this.onChange}
                  onKeyPress={this.onChange}
                  data-option={item.ID}
                  key={`${item.ID}_${index}`}
                  id={item.ID}
                  role="option"
                >
                <span className='select-item-dot'>
                  <Icon
                    name="tick.svg"
                    width="12px"
                    height="12px"
                    classes="tick-icon"
                  />
                 </span>
                    <div
                      className='select-item-text'
                      id={item.ID}
                      onMouseLeave={this.hideTooltip()}
                      onMouseEnter={this.showTooltip(id, item.Name, 'select-item-text')}
                    >{item.Name}</div>
                </div>
              )
            })}
          </div>
          {
            tooltipTarget && this.ellipsisIsShown()
            && <Tooltip
              isOpen
              hideArrow
              placement="bottom-end"
              text={tooltipTarget.name}
              target={document.querySelector(`.${tooltipTarget.className}[id="${tooltipTarget.id}"]`)}
            />
          }
        </div>
      </ClickListener>
    )
  }
}

SelectUi.propTypes = {
  onInputChanged: PropTypes.func.isRequired,
  optionsEnums: PropTypes.arrayOf(
    PropTypes.shape({
      ID: PropTypes.string,
      Name: PropTypes.string
    })
  ).isRequired,
  value: PropTypes.string
}

export default SelectUi
